import {
  mapState,
  mapMutations
} from "vuex";
import $ from 'jquery'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Swal from 'sweetalert2'
import api from '../service/services'
import showshift from "../components/modal/shiftstatus";
import showcloseshift from "../components/modal/showcloseshift";
export default {
  data() {
    return {
      tester: "asdasd",
      menus: [],
      hardware: {
        edc: 'Terminal not ready',
        ws: this.$store.state.wsStatus,
        ca: 'Close',
        ba: 'Close',
        qr: 'Close',
        printer: 'Close'
      },
      IDWallet: '',
      OTP: '',
      shift_step: 1,
      HWdata: {
        ca: 'Online', // เครื่องทอนเหรียญ
        ba: 'Online', // เครื่องรับแบงค์
        ch: 'Online', // เครื่องทอนเหรียญ
        nd: 'Online', // เครื่องทอนแบงค์
        nd2: 'Online', // เครื่องทอนแบงค์
        printer: 'Online', // ปริ้นเตอร์
        frontdoor: 'Close', // ฝาตู้
        cashbox: 'Close', // ตู้เก็บเงิน
        qr: 'Online', // ตัวอ่านบัตรเครดิต
        edc: 'Terminal ready' // ตัวอ่านบัตรเครดิต
      },
      step_closeshift: ''
    }
  },
  components: {
    Loading,
    showshift,
    showcloseshift
  },
  computed: {
    ...mapState([
      "UUID",
      "accessToken",
      "AuthenType",
      "coins_close",
      'isLoading',
      "ui_mode"
    ]),
    ...mapMutations(["onMessageWs"])
  },
  methods: {
    set() {
      const data = [
        {
          title: 'เปิดกะ',
          image: require('../assets/open_shift.png'),
          func: 'open_shift'
        },
        {
          title: 'ปิดกะ',
          image: require('../assets/close_shift.png'),
          func: 'close_shift'
        },
        {
          title: 'เติมเงิน',
          image: require('../assets/banknote.png'),
          func: 'refill'
        },
        {
          title: 'เปิดฝาตู้',
          image: require('../assets/opendoor.png'),
          func: 'open_door'
        },
        {
          title: 'Mode',
          image: require('../assets/share.png'),
          func: 'changeMode'
        },
        {
          title: 'Test',
          image: require('../assets/technical-support.png'),
          func: 'testHw'
        },
        {
          title: 'ปิดเครื่อง',
          image: require('../assets/power-off.png'),
          func: 'shutdown'
        }
      ]
      data.forEach(val => {
        if (val['func'] == 'open_shift') {
          if (this.$store.state.shift_uuid == '') {
            this.menus.push(val)
          }
        } else if (val['func'] == 'close_shift') {
          if (this.$store.state.shift_uuid != '') {
            this.menus.push(val)
          }
        }
        else if (val['func'] == 'refill') {
          if (this.$store.state.shift_uuid != '') {
            this.menus.push(val)
          }
        }
        else if (val['func'] == 'testHw') {
          if (this.$store.state.shift_uuid != '') {
            this.menus.push(val)
          }
        }
        else {
          this.menus.push(val)
        }
      })
    },
    back() {
      this.Soundclick()
      this.$router.push('/')
    },
    func(text) {
      this.Soundclick()
      switch (text) {
        case 'shutdown':
          this.$store.state.isLoading = true
          Swal.fire({
            title: 'ยืนยันการปิดเครื่อง?',
            text: "เมื่อคุณตกลงเครื่องจะทำการปิดตัว!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
          }).then((result) => {
            if (result.value) {
              this.$socket.sendObj({
                Device: 'host',
                type: 'request',
                command: 'shutdown'
              })
            }
          })
          setTimeout(() => {
            if (this.$store.state.isLoading == true) {
              this.$store.state.isLoading = false
              Swal(
                'แจ้งเตือน',
                'Web Socket ปิดเครื่อง ไม่ตอบสนองตามเวลาที่กำหนด',
                'error'
              )
            }
          }, 3000)
          break
        case 'open_door':
          const header = {
            headers: {
              'x-access-token': this.$store.state.accessToken
              // "x-access-token": '942be569a799418c9b4249dc964e7930'
            }
          }
          this.$store.state.isLoading = true
          api.openDoorLine(
            header,
            result => {
              console.log(result)
              if (result.Response === 'success') {
                this.$socket.sendObj({
                  Device: 'host',
                  type: 'request',
                  command: 'open_front_door',
                  data: 20
                })
                Swal(
                  'แจ้งเตือน',
                  'เปิดฝาตู้สำเร็จ!!',
                  'success'
                )
              }
              this.$store.state.isLoading = false
            },
            error => {
              console.log(error)
              Swal(
                'แจ้งเตือน',
                'เปิดฝาตู้มีปัญหา!!',
                'error'
              )
              this.$store.state.isLoading = false
            })
          setTimeout(() => {
            if (this.$store.state.isLoading == true) {
              this.$store.state.isLoading = false
              Swal(
                'แจ้งเตือน',
                'Web Socket เปิดฝาตู้ ไม่ตอบสนองตามเวลาที่กำหนด',
                'error'
              )
            }
          }, 3000)
          break
        case 'refill':
          this.$router.push('/refill')
          break
        case 'close_shift':
          this.shift()
          break
        /////////////// Coins_change Version /////////////////////
        // case 'close_shift':
        //     this.$socket.sendObj({
        //       Device: 'host',
        //       type: 'request',
        //       command: 'empty',
        //     });
        //     this.$store.state.isLoading = true
        //     this.step_closeshift = setInterval(() => {
        //       if (this.$store.state.coins_close) {
        //         console.log("log",this.$store.state.coins_close)
        //         // this.shift_new();
        //         clearInterval(this.step_closeshift);
        //       }
        //     }, 1000);
        //   break
        case 'testHw':
          this.$router.push('/TestHw')
          break
        case 'changeMode':
          this.$router.push('/mode')
          break
        default:
          // $('#ShiftModal').modal('show')
          // this.shift()
          break
      }
    },
    refillmonney() {
      const header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      }
      var playload = {
        amount: this.open_shift_amount
      }
      console.log("playload", playload)
      api.shiftOpenV2(
        playload,
        header,
        result => {
          if (result == "success") {
            Swal.fire({
              position: 'top-end',
              type: 'success',
              title: 'เปิดกะสำเร็จ!! ' + JSON.stringify(error),
              showConfirmButton: true
            })
          }
        },
        error => {
          console.log("error", error)
          alert(error)
        }
      )
    },
    shift() {
      const header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      }
      console.log(header)
      Swal.fire({
        title: 'ยืนยันการทำรายการ?',
        text: 'ท่านต้องการปิดกะ ใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(result => {
        if (result.value) {
          Swal.fire({
            position: 'center',
            type: 'warning',
            title: 'ท่านกำลังทำการปิดกะ',
            showConfirmButton: false,
            timer: 1500
          })
          // var playload = { //empty
          //   note: this.state.coins_close.note,
          //   note1: this.state.coins_close.note2,
          //   coin: this.state.coins_close.coin
          // }
          this.$store.state.isLoading = true
          var shift_uuid_befor = this.$store.state.shift_uuid
          api.shitfClose(
            { shift_uid: this.$store.state.shift_uuid },
            header,
            result => {
              if (result.response === 'success') {
                Swal.fire({
                  position: 'center',
                  type: 'success',
                  title: 'ปิดกะสำเร็จ!!',
                  showConfirmButton: false,
                  timer: 1500
                })
                this.shift_amount = result.shift_amount;
                this.B1000 = result.payment.b1000;
                this.B500 = result.payment.b500;
                this.B100 = result.payment.b100;
                this.B50 = result.payment.b50;
                this.B20 = result.payment.b20;
                this.C10 = result.payment.c10;
                this.C5 = result.payment.c5;
                this.C2 = result.payment.c2;
                this.C1 = result.payment.c1;
                this.C050 = result.payment.c050;
                this.C025 = result.payment.c025;
                this.$store.state.shift_uuid = result.new_shift_uid
                // this.state.coins_close = {}
                console.log('new shift ' + this.$store.state.shift_uuid)
                console.log(result)

                var data_slip = {
                  "command":"print_shift_close",
                  "data":{
                    "id": 1,
                    "shift_uuid": shift_uuid_befor,
                    "type":"close",
                    "shift_at":"2018-11-11T17:00:00.00Z",
                    "is_closed": true,
                    "is_posted": true,
                    "b1000": result.payment.b1000,
                    "b500": result.payment.b500,
                    "b100": result.payment.b100,
                    "b50": result.payment.b50,
                    "b20": result.payment.b20,
                    "c10": result.payment.c10,
                    "c5": result.payment.c5,
                    "c2": result.payment.c2,
                    "c1": result.payment.c1,
                    "diff_change_note_qty": 0,
                    "count_change_note_value": 0,
                    "diff_change_note_value": 0,
                    "coin_count_value": 180,
                    "diff_coin_value": 0,
                    "unpaid_amount": 0,
                    "shop_title": "Paybox cafe",
                    "vending_id": 102,
                    "count_sales_tx": 0,
                    "count_unpost_sales_tx": 0,
                    "change_note_value": 0,
                    "total_unpaid_change": 0
                }
              }
                console.info(JSON.stringify(data_slip))
                this.$socket.sendObj(data_slip)
              } else {
                Swal.fire({
                  type: 'error',
                  title: 'การปิดกะมีปัญหา !! ' + result.message,
                  showConfirmButton: true
                })
              }
              this.$store.state.AuthenType = 5
              $("#Modal").modal("show");
              this.$store.state.isLoading = false
            },
            error => {
              console.log(error)
              Swal.fire({
                position: 'top-end',
                type: 'success',
                title: 'ปิดกะไม่สำเร็จ!! ' + JSON.stringify(error),
                showConfirmButton: true
              })
              this.$store.state.isLoading = false
            }
          )
          setTimeout(() => {
            if (this.$store.state.isLoading == true) {
              this.$store.state.isLoading = false
              Swal(
                'แจ้งเตือน',
                'Web Socket เปิดตู้เก็บเงิน ไม่ตอบสนองตามเวลาที่กำหนด',
                'error'
              )
            }
          }, 3000)
        }
      })
      // }
    },
    shift_new() {
      const header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      }
      console.log(header)
      if (this.$store.state.shift_uuid == '') {
        Swal.fire({
          position: 'top-end',
          type: 'success',
          title: 'ท่านกำลังทำการเปิดกะ',
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        Swal.fire({
          title: 'ยืนยันการทำรายการ?',
          text: 'ท่านต้องการปิดกะ ใช่หรือไม่?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then(result => {
          if (result.value) {
            Swal.fire({
              position: 'center',
              type: 'warning',
              title: 'ท่านกำลังทำการปิดกะ',
              showConfirmButton: false,
              timer: 1500
            })
            // var playload = { //empty
            //   note: this.state.coins_close.note,
            //   note1: this.state.coins_close.note2,
            //   coin: this.state.coins_close.coin
            // }
            var body = {
              shift_uid: this.$store.state.shift_uuid,
              total: this.$store.state.coins_close
            }
            this.$store.state.isLoading = true
            api.shitfClose(
              body,
              header,
              result => {
                if (result.response === 'success') {
                  Swal.fire({
                    position: 'center',
                    type: 'success',
                    title: 'ปิดกะสำเร็จ!!',
                    showConfirmButton: false,
                    timer: 1500
                  })
                  this.shift_amount = result.shift_amount;
                  this.B1000 = result.payment.b1000;
                  this.B500 = result.payment.b500;
                  this.B100 = result.payment.b100;
                  this.B50 = result.payment.b50;
                  this.B20 = result.payment.b20;
                  this.C10 = result.payment.c10;
                  this.C5 = result.payment.c5;
                  this.C2 = result.payment.c2;
                  this.C1 = result.payment.c1;
                  this.C050 = result.payment.c050;
                  this.C025 = result.payment.c025;
                  this.$store.state.shift_uuid = result.new_shift_uid
                  this.$store.state.coins_close = {}
                  console.log('new shift ' + this.$store.state.shift_uuid)
                  console.log(result)
                } else {
                  Swal.fire({
                    type: 'error',
                    title: 'การปิดกะมีปัญหา !! ' + result.message,
                    showConfirmButton: true
                  })
                }
                this.$store.state.AuthenType = 5
                $("#Modal").modal("show");
                this.$store.state.isLoading = false
              },
              error => {
                console.log(error)
                Swal.fire({
                  position: 'top-end',
                  type: 'success',
                  title: 'ปิดกะไม่สำเร็จ!! ' + JSON.stringify(error),
                  showConfirmButton: true
                })
                this.$store.state.isLoading = false
              }
            )
            setTimeout(() => {
              if (this.$store.state.isLoading == true) {
                this.$store.state.isLoading = false
                Swal(
                  'แจ้งเตือน',
                  'Web Socket เปิดตู้เก็บเงิน ไม่ตอบสนองตามเวลาที่กำหนด',
                  'error'
                )
              }
            }, 3000)
          }
        })
      }
    },
    websocket_onmessage() {
      this.$socket.onmessage = skResult => {
        this.$store.state.wsStatus = true
        var data = JSON.parse(skResult.data)
        if (data.command == 'status') {
          this.hardware.edc = data.data.edc
          this.hardware.ca = data.data.ca
          this.hardware.ba = data.data.ba
          this.hardware.qr = data.data.qr
          this.hardware.printer = data.data.printer
          this.hardware.ws = this.$store.state.wsStatus
        } else {
          this.$store.commit('onMessageWs', data)
        }
      }
    },
    addKey(int) {
      this.Soundclick()
      if (this.shift_step == 1) {
        if (this.IDWallet.length < 13) {
          this.IDWallet += int
        }
      } else {
        if (this.OTP.length < 6) {
          this.OTP += int
        }
      }
    },
    removeKey() {
      this.Soundclick()
      if (this.shift_step == 1) {
        var key = this.IDWallet
        this.IDWallet = key.substring(key.length - 1, 0)
      } else {
        var key = this.OTP
        this.OTP = key.substring(key.length - 1, 0)
      }
    },
    sendOTP() {
      this.Soundclick()
      if (this.shift_step == 1) {
        if (this.IDWallet != '') {
          this.shift_step = 2
        }
      } else {
        if (this.OTP != '') {
          $('#ShiftModal').modal('hide')
          this.shift()
        }
      }
    },
    ShowStatusShift() {
      this.Soundclick()
      this.$store.state.AuthenType = 4
      $("#Modal").modal("show");
    },
    selectModal() {
      this.Soundclick()
      this.$store.state.AuthenType = 4
      $("#ModalMode").modal("show");
    },
    modeSwitch(mode) {
      api.switchMode(mode)
      this.Soundclick()
      if (mode == 0) {
        this.$store.state.ui_mode = 0
        Swal.fire({
          position: 'center',
          type: 'success',
          title: 'เปลี่ยนเป็น Product Mode',
          showConfirmButton: false,
          timer: 1500
        })
        console.log()
      }
      if (mode == 1) {
        this.$store.state.ui_mode = 1
        Swal.fire({
          position: 'center',
          type: 'success',
          title: 'เปลี่ยนเป็น Test Mode',
          showConfirmButton: false,
          timer: 1500
        })
        console.log()
      }
    },
  },
  mounted() {
    if (this.$store.state.shift_uuid) {
      this.websocket_onmessage()
      this.set()
      this.checkCloseWebsocket()
      this.checkWebsocket()
      $('#ShiftModal').on(
        'hidden.bs.modal',
        function () {
          this.IDWallet = ''
          this.OTP = ''
        }.bind(this)
      )
      $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal')
      })
      this.$socket.sendObj({
        Device: 'host',
        type: 'request',
        command: 'status'
      })
    } else {
      // this.$router.push('/')
      this.websocket_onmessage()
      this.set()
      this.$socket.sendObj({
        Device: 'host',
        type: 'request',
        command: 'status'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/setting.js